export function removeTime(param) {
  return param?.slice(0,10) || param;
}
